/**
 * @generated SignedSource<<e8a67d101331da535d768c5d7102dd1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type JwtService = "EDITOR" | "STUDIO" | "UPLOAD" | "%future added value";
export type authJwtQuery$variables = {
  event?: string | null | undefined;
  ocId?: string | null | undefined;
  service: JwtService;
};
export type authJwtQuery$data = {
  readonly serviceJwt: string;
};
export type authJwtQuery = {
  response: authJwtQuery$data;
  variables: authJwtQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "event"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ocId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "service"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "opencastId",
        "variableName": "ocId"
      },
      {
        "kind": "Variable",
        "name": "service",
        "variableName": "service"
      }
    ],
    "kind": "ScalarField",
    "name": "serviceJwt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "authJwtQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "authJwtQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f5331382dbdcedf3e89cd988cc6b08df",
    "id": null,
    "metadata": {},
    "name": "authJwtQuery",
    "operationKind": "query",
    "text": "query authJwtQuery(\n  $service: JwtService!\n  $event: ID\n  $ocId: String\n) {\n  serviceJwt(service: $service, event: $event, opencastId: $ocId)\n}\n"
  }
};
})();

(node as any).hash = "f7f0d5cb594e978051f6e6e9b0471fcf";

export default node;
